module.exports = __webpack_public_path__ + "static/media/koalefanttrunk.c5cd6d14.webp";